<template>
    <div class="mobile-hide shadow-1" color="white">
        <div class="row q-py-md q-px-md fit justify-center">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-2">
                        <img :src="logo" height="auto" style="max-width: 100%;" />
                    </div>

                    <div class="col-10 text-right self-center">
                        <span v-for="(button, index) in getNavbarOrder" :key="index">
                            <q-btn flat size="lg"
                                :color="button.to == $route.meta.title ? 'primary' : 'secondary'"
                                :label="$t(button.text)"
                                @click="$router.push({ name: button.to })"
                                v-if="button.to"
                            />

                            <q-btn-dropdown flat size="lg" :label="button.text" v-if="!button.to && button.buttons.length > 0" :color="getColorButtonMerged" >
                                <q-list >
                                    <q-item link v-for="(b, index) in button.buttons" :key="`b-${index}`" :to="{ name: b.to }">
                                        <q-item-main>
                                            <q-item-tile label>{{ $t(b.text) }}</q-item-tile>
                                        </q-item-main>
                                    </q-item>
                                </q-list>
                            </q-btn-dropdown>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "authenticated"] },

    data() {
        return {
            logo: '',
            show_merged: false
        }
    },

    computed: {
        ...mapGetters({
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getNavbarOrder() {
            let navbar = []

            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    if (obj.has_home) {
                        navbar.push({
                            icon: 'far fa-home',
                            to: 'home',
                            text: obj.title_home == '' ? 'home' : obj.title_home
                        })
                    }

                    if (!obj.has_merged_content) {
                        if (obj.has_courses) {
                            navbar.push({
                                icon: 'far fa-book-reader',
                                to: 'courses',
                                text: obj.title_trainings == '' ? 'courses' : obj.title_trainings
                            })
                        }

                        if (obj.has_trails) {
                            navbar.push({
                                icon: 'far fa-bezier-curve',
                                to: 'trails',
                                text: obj.title_trails == '' ? 'trails' : obj.title_trails
                            })
                        }

                        if (obj.has_presential) {
                            navbar.push({
                                icon: 'far fa-users-class',
                                to: 'presential',
                                text: obj.title_presential == '' ? 'presential' : obj.title_presential
                            })
                        }

                        if (obj.has_webcasts) {
                            navbar.push({
                                icon: 'far fa-broadcast-tower',
                                to: 'webcasts',
                                text: obj.title_webcasts == '' ? 'webinars' : obj.title_webcasts
                            })
                        }

                        if (obj.has_podcasts) {
                            navbar.push({
                                icon: 'far fa-podcast',
                                to: 'podcasts',
                                text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts
                            })
                        }

                        if (obj.has_live_classes) {
                            navbar.push({
                                icon: 'fal fa-chalkboard-teacher',
                                to: 'live_classes',
                                text: obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes
                            })
                        }
                    }
                    else {
                        let buttons = []

                        if (obj.has_courses) {
                            buttons.push({
                                icon: 'far fa-book-reader',
                                to: 'courses',
                                text: obj.title_trainings == '' ? 'courses' : obj.title_trainings
                            })
                        }

                        if (obj.has_trails) {
                            buttons.push({
                                icon: 'far fa-bezier-curve',
                                to: 'trails',
                                text: obj.title_trails == '' ? 'trails' : obj.title_trails
                            })
                        }

                        if (obj.has_presential) {
                            buttons.push({
                                icon: 'far fa-users-class',
                                to: 'presential',
                                text: obj.title_presential == '' ? 'presential' : obj.title_presential
                            })
                        }

                        if (obj.has_webcasts) {
                            buttons.push({
                                icon: 'far fa-broadcast-tower',
                                to: 'webcasts',
                                text: obj.title_webcasts == '' ? 'webcasts' : obj.title_webcasts
                            })
                        }

                        if (obj.has_podcasts) {
                            buttons.push({
                                icon: 'far fa-podcast',
                                to: 'podcasts',
                                text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts
                            })
                        }

                        if (obj.has_live_classes) {
                            buttons.push({
                                icon: 'fal fa-chalkboard-teacher',
                                to: 'live_classes',
                                 text: obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes
                            })
                        }

                        navbar.push({
                            icon: 'far fa-broadcast-tower',
                            text: obj.merged_content_title ? this.$t(obj.merged_content_title) : this.$t('trainings'),
                            buttons: buttons,
                            to: ''
                        })
                    }

                    if (obj.has_library) {
                        navbar.push({
                            icon: 'far fa-books',
                            to: 'library',
                            text: obj.title_library == '' ? 'library' : obj.title_library
                        })
                    }

                    if (obj.has_news) {
                        navbar.push({
                            icon: 'far fa-newspaper',
                            to: 'news',
                            text: obj.title_news == '' ? 'news' : obj.title_news
                        })
                    }

                    if (obj.has_feed) {
                        navbar.push({
                            icon: 'far fa-comment-alt-smile',
                            to: 'feed',
                            text: obj.title_feed == '' ? 'feed' : obj.title_feed
                        })
                    }

                    if (obj.has_faq) {
                        navbar.push({
                            icon: 'far fa-question-square',
                            to: 'faq',
                            text: obj.title_faq == '' ? 'faq' : obj.title_faq
                        })
                    }

                    if (obj.has_profile) {
                        navbar.push({
                            icon: 'far fa-user',
                            to: 'profile',
                            text: obj.title_profile == '' ? 'profile' : obj.title_profile
                        })
                    }
                }

                let index = navbar.findIndex(x => x.to === obj.home_route)
                if (index && index != 0) {
                    navbar.unshift(navbar.splice(navbar.findIndex(item => item.to === obj.home_route), 1)[0])
                }
            }

            return navbar
        },

        getColorButtonMerged() {
            let routes = ['courses', 'trails', 'webcasts', 'presential', 'podcasts']

            if (routes.includes(this.$route.meta.title)) return 'primary'
            else return 'secondary'
        }
    },

    methods: {
        changeLogo() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
				this.logo = client.logo
			}
        },
    },

    watch: {
		params_loaded: function() {
            this.changeLogo()
        },

        id_user_client_selected: function() {
            this.changeLogo()
        }
	},

    mounted() {
		if (this.clients) {
			this.changeLogo()
		}
	}
}
</script>

<style>

</style>
